import * as actions from './actions';
import * as getters from './getters';

import { SET_IS_FOOTER_SHOWN } from '../mutation-types';

const mutations = {
  [SET_IS_FOOTER_SHOWN](state, payload) {
    state.isShown = payload;
  },
};

const state = () => ({
  isShown: true,
});

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
